import { Schedule } from "@aura-frontend/omnibus-az-client";
import { useQueries } from "@tanstack/react-query";

import { scheduleMonthQueryOptions } from "../FieldSchedule/FieldSchedule.queries";
import { CalendarRange } from "./FieldCalendar";

/**
 * Visible calendar months (0-indexed) covered by a range.
 */
function getMonthsFromRange(
  range: CalendarRange,
): { year: number; month: number }[] {
  // range strings are Temporal ISO format: "2024-04-08T00:00:00+00:00[UTC]"
  const [startYear, startMonth1] = range.start
    .split("T")[0]
    .split("-")
    .map(Number);
  const [endYear, endMonth1] = range.end.split("T")[0].split("-").map(Number);

  const startMonth = startMonth1 - 1; // 0-indexed
  const endMonth = endMonth1 - 1;

  const months: { year: number; month: number }[] = [
    { year: startYear, month: startMonth },
  ];
  if (startYear !== endYear || startMonth !== endMonth) {
    months.push({ year: endYear, month: endMonth });
  }
  return months;
}

export const useCalendarEvents = ({
  machineUuid,
  range,
  refetchIntervalMs,
}: {
  machineUuid: string | undefined;
  range: CalendarRange;
  refetchIntervalMs?: number;
}) => {
  const months = getMonthsFromRange(range);
  const fieldIds = machineUuid ? [machineUuid] : [];

  const queries = useQueries({
    queries: months.map(({ year, month }) => ({
      ...scheduleMonthQueryOptions(fieldIds, year, month, refetchIntervalMs),
      enabled: !!machineUuid,
    })),
  });

  const events: Schedule[] = queries
    .flatMap((q) => q.data ?? [])
    .sort((a, b) => a.schedule_time_s - b.schedule_time_s);

  const isLoading = queries.some((q) => q.isLoading);

  return { events, isLoading };
};
